module.exports = __webpack_public_path__ + "static/media/creativeagency.836ac4d9.jpg";